import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 5,
        marginBottom: 5
    },
    billTo: {
        color: '#000',
        fontSize: 12,
        textAlign: 'left',
    },
  });


  const BillTo = ({invoice}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>Booking Details</Text>
    </View>
  );
  
  export default BillTo